<template>
    <div class="row list--plans" id="ChoosePlan">
        
        <template v-if="typePayment == 'contract'">
            <div v-if="planSelection">
                <div
                    v-for="(plan, index) in listPlans"
                    :key="index"
                    @click="changePlan(plan.id)"
                >
                    <PlanCard
                        :plan="plan"
                        :cupom="cupom"
                        :forward="forward"
                        :activePrice="activePrice"
                        class="mb-3"
                    />
                </div>
            </div>

            <div v-else>
                <div
                    v-for="(plan, index) in listPlans"
                    :key="index"
                    @click="planSelection = true"
                >
                    <PlanCard
                        :plan="plan"
                        :cupom="cupom"
                        :forward="forward"
                        :activePrice="activePrice"
                        :change="listPlans.length > 1 ? true : false"
                        v-if="plan.id == activePrice"
                        class="mb-3"
                    />
                </div>
            </div>

            <div v-for="(plan, index) in listPlans" :key="index">
                <div v-if="plan.id == activePrice" class="row">
                    <div class="col-6">
                        <p class="small--text"><strong>Total a pagar</strong></p>
                        <div v-if="!cupom.discount">
                            <strong>R$ {{ calculateTotalPrice(plan) }}</strong>
                        </div>
                        <div v-else>
                            <p class="value--off small--text mb-0">
                                de {{ plan.support.replace(".", ",") }} por
                            </p><strong>R$ {{ calculateTotalPrice(plan, true) }}</strong>
                        </div>
                    </div>

                    <div v-if="plan.price_cicle == 1" class="col-6">
                        <p class="small--text"><strong>Mensalidade após o 2º mês</strong></p>
                        <div>
                            <strong>R$ {{ plan.price_value.replace(".", ",") }}</strong>
                        </div>
                    </div>

                    <div v-else class="col-6">
                        <p class="small--text">
                            <strong>Recorrência a cada {{ plan.price_cicle }} meses</strong>
                        </p>
                        <div>
                            <strong>R$ {{ plan.price_value.replace(".", ",") }}</strong>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="card p-2 active" v-if="billData.value">
                <div class="row">
                    <div class="col-12 text-left">
                         <p class="mb-2">{{ billData.observation }}</p>
                    </div>
                    <div class="col-12 text-left mt-3">
                        <span><strong>Total a pagar</strong></span>
                        <span class="float-right"><strong>{{ billData.value | toCurrency }}</strong></span>
                    </div>
                </div>
            </div>
        
        </template>

        <div class="form-group text-left mt-3">
            <label for="listPrices">Forma de pagamento</label>
            <select
                name="listPrices"
                id="listPrices"
                class="form-control"
                v-model="paymentMethod"
            >
                <option
                v-for="(option, index) in priceOptions"
                :key="index"
                :value="option.value"
                >
                {{ option.text }}
                </option>
            </select>
        </div>
        <p class="errors" v-if="errors.documentId">{{errors.documentId}}</p>
    </div>
</template>

<script>
import PlanCard from "../molecules/PlanCard.vue";

export default {
    name: "ChoosePlan",
    data: () => {
        return {
            planSelection: false,
            paymentMethod: null,
            errors: {},
        };
    },
    components: {
        PlanCard
    },
    props: {
        typePayment:{
            required: true
        },
        listPlans : {
            required: true
        },
        activePaymentMethod : {
            required: true
        },
        priceOptions : {
            required: true
        },
        activePrice : {
            required: true
        },
        forward : {
            required: true
        },
        cupom : {
            required: true
        },
        billData : {
            required: true
        },
    },
    watch:{
        paymentMethod(){
            this.$emit('paymentMethod',this.paymentMethod)
        },
        activePaymentMethod(){
            this.paymentMethod = this.activePaymentMethod
        },
    },
    created(){
        this.paymentMethod = this.activePaymentMethod
    },
    filters: {
        toCurrency(value) {
            value = parseFloat(value);
            if (typeof value !== "number") {
                return value;
            }
            var formatter = new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
                minimumFractionDigits: 2,
            });
            return formatter.format(value);
        },
    },
    methods:{
        checkError(){
            if (this.typePayment == "contract" && this.activePrice == null) {
                this.$set(this.errors, 'plane', "Escolha um plano");
            }
            else {
                this.$delete(this.errors,'documentId');
            }
            this.$emit('errorNumbers',Object.keys(this.errors).length)
        },
        changePlan(choice) {
            this.planSelection = false;
            this.$emit('onActivePrice',choice)
	    },
        calculateTotalPrice(plan, discount = false){
            let total = parseFloat(plan.support);
            let value = parseFloat(plan.price_value);

            if(discount && this.cupom){
                total = total - parseFloat(this.cupom.discount);
            }

            if(total <= 0){
                total = value;
            }
            else if(plan.price_cicle > 1){
                total = total + value;
            }

            return total.toFixed(2).replace(".", ",");
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/organisms/CheckoutStepChoosePlan.vue